import { actionTypes } from "../../constants/ImageViewer";

export const setImage = href => dispatch =>
  dispatch({ type: actionTypes.SET_IMAGE_HREF, payload: href });

export const clearImage = () => dispatch => {
  dispatch({ type: actionTypes.CLEAR_IMAGE_HREF });
};
